module.exports = __webpack_public_path__ + "img/bg-product-3.ff760b8d.png";